import React, {useEffect} from "react";
import { Provider, observer } from 'mobx-react'
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';

import GlobalStyles from 'styles/global'
import { stores } from 'stores'
import { Routing } from 'routing'
import { useStores } from 'hooks/useStores'
import { messages } from 'i18n/messages';
import { LocalesEnum } from 'interfaces/ui';
import {useLocation} from "react-router-dom";


function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

const App = observer(() => {
    const {uiStore} = useStores();
    const messageData = messages[uiStore.getLocale] || messages[LocalesEnum.ENGLISH];

    return (
        <Provider {...stores}>
            <IntlProvider
                messages={messageData}
                locale={uiStore.getLocale}
                defaultLocale={LocalesEnum.RUSSIAN}
            >
                <ThemeProvider theme={uiStore.theme}>
                    <Routing/>
                    <ScrollToTop/>
                    <GlobalStyles/>
                </ThemeProvider>
            </IntlProvider>
        </Provider>
    );
})

export default App;
